import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=3e727ab4&scoped=true"
var script = {}
import style0 from "./Areas.vue?vue&type=style&index=0&id=3e727ab4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e727ab4",
  null
  
)

export default component.exports